import { isSpSize } from "../common/utils/isSpSize";

class ResetAndGo {
  // ---------------------------------------------------------------------------
  // --	ResetAndGo
  // ---------------------------------------------------------------------------

  constructor() {
    //DOM参照
    this.$elm = document.querySelector(".js-reset-and-go");

    //スクロールハンドリング
    window.addEventListener("scroll", this.update.bind(this));

    //リサイズハンドリング
    window.addEventListener("resize", this.update.bind(this));

    //初回アップデート
    this.update();
  }

  update() {
    if (isSpSize()) {
      this.$elm.removeAttribute("style");
      return;
    }

    //スクロール量とWindowの高さ
    const scrollY = window.scrollY;
    const windowH = window.innerHeight;

    //LASTエリアのY座標
    const targetY = this.$elm.getBoundingClientRect().y;

    //表示判定用座標
    const msgStartY = windowH;
    const msgEndY = -windowH / 2;

    //スクロール表示
    let rate = (targetY - msgStartY) / (msgEndY - msgStartY);
    if (rate < 0) {
      rate = 0;
    } else if (rate > 1) {
      rate = 1;
    }
    gsap.set(this.$elm, {
      x: -100 * rate + "rem",
    });
  }

  // ---------------------------------------------------------------------------
}

export default ResetAndGo;
